export interface NavItem {
  id: number;
  title: string;
  description: string;
  icon: any;
  themeColor?: string;
  path: string;
  sub_path?: string;
}
export const CoordinatorNav: NavItem[] = [
  {
    id: 1,
    icon: <span className="material-symbols-outlined">home </span>,
    title: "Home",
    themeColor: "",
    path: "/coordinator",
    description: "",
    sub_path: "template",
  },
  // {
  //   id: 2,
  //   icon: <span className="material-symbols-outlined">description</span>,
  //   title: "Nursing student list",
  //   path: "nursingstudentlist",
  //   description: "",
  //   themeColor: "",
  // },
  // {
];
